import React, { useState , useEffect} from "react";
import Container from "@mui/material/Container";
import { Grid, Box } from "@mui/material";

import backgroundImage from "../../../assets/background.jpeg";
import People from "../../../assets/people.png";
import Palmyra from "../../../assets/Palmyra.png";
import Dama from "../../../assets/dama.png";
import Nature from "../../../assets/nature.png";
import { ToastContainer, toast } from 'react-toastify';
import HeroCard from "../HeroCard/HeroCard";
import axios from "axios";
import logo from '../../../../src/assets/multaqalogo.png'

export default function Hero() {
  
 
  
  
  

  
  return (
   
    <>
  

      <Box
       sx={{
         flexGrow: 1,
         marginTop: "1rem",
         height: { sx: "auto", md: "100vh" },
       }}
     >
       <Grid container spacing={1}>
         {/* First card on the left side */}
         <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
           <Box sx={{marginTop:'150px'}}>
          <img style={{width:'100%'}} src={logo} alt="" />
           </Box>
         </Grid>
         <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Grid sx={{ textAlign:'center', direction:'rtl'}} container spacing={1}>
          <h1 style={{textAlign:'center', marginTop:'250px'}}>
          "ملتقى القوى الوطنية الديمقراطية" 
          </h1>
          <p style={{fontSize:'26px', padding:'16px', textAlign:'justify'}}>
          في سوريا  تعبير عن إرادة جماعية صلبة لتوحيد صفوف القوى الديمقراطية الوطنية،
          بمشاركة حيوية من كل فئات المجتمع وخاصة الشباب والمرأة، تهدف الى بناء الدولة السورية الحديثة على أسس راسخة من العدالة، والمواطنة، والتعددية، والسيادة الوطنية.
          </p>
          </Grid>
          
        </Grid>
       </Grid>
     </Box>
  
    </>
  );
}
